import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BulkUpload from '../Commons/BulkUpload';

import { CopyIcon } from './Styles/Icons';
import { FlexRow, Bold, InputGroup, Select, MenuItem, SectionRow, InputAdornment } from './Styles/DeleteBulkItems';

import { updateErrorMessage, updateSuccessMessage, updateMessage, updateError } from '../../actions/commonActions';
import { setUploadInventoryFileAction, setUploadInventoryFileBatch, downloadTemplateFile, uploadFilledTemplateFile } from '../../actions/inventoryActionsV2';
import { fetchSPJBatchJobs, fetchSPJBatchMetric, clearSPJFailed, downloadSPJErrors } from '../../actions/spjActions';

import { SPJ_ACTIONS, hideDSOInfo } from '../../commons/utils';

class DeleteBulkItems extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedDeleteOption: "",
			mappedDSOIds: []
		};
	}

	componentDidMount() {
		if(this.props.deleteOptions.find((option) => (option.value === this.props.uploadInventoryFileAction))){
			this.setState({selectedDeleteOption: this.props.uploadInventoryFileAction})
		}
	}

	handleInput = (key, value, next = null) => {
		this.setState(
			{
				[key]: value,
			},
			next
		);
	};

	handleCopyInput = (value) => {
		navigator.clipboard.writeText(value);
		this.props.updateMessage(true, 'Copied to clipboard');
	};

	downloadTemplateFile = async (action, onError) => {
		await this.props.downloadTemplateFile(action, onError);
	};

	uploadFilledTemplateFile = async (action, formData, onSuccess, onError) => {
		await this.props.uploadFilledTemplateFile(action, formData, onSuccess, onError);
	};

	render() {
		let { selectedDeleteOption, mappedDSOIds } = this.state;
		let { open, uploadInventoryFileAction, uploadInventoryFileBatch, uploadInventoryFileType, mappedDSOOptions,
			groupId, deleteOptions } = this.props;

		return open ? (
			<>
				<BulkUpload
					open={open}
					title={'Delete Inventory Items In Bulk'}
					spjAction={selectedDeleteOption}
					uploadFileAction={uploadInventoryFileAction || ''}
					uploadFileBatch={uploadInventoryFileBatch || ''}
					uploadFileType={uploadInventoryFileType || ''}
					disableDownload={!selectedDeleteOption}
					disableUpload={!selectedDeleteOption}
					onClose={this.props.toggle}
					onSuccess={this.props.onSuccess}
					downloadTemplateFile={this.downloadTemplateFile}
					uploadFilledTemplateFile={this.uploadFilledTemplateFile}
					setUploadFileAction={this.props.setUploadInventoryFileAction}
					setUploadFileBatch={this.props.setUploadInventoryFileBatch}
				>
					<FlexRow style={{ margin: '0.5rem auto', textAlign: 'center' }}>
						Download the sample file and add product details. Upload the file to delete the items for inventory or a paticular index at once.
					</FlexRow>

					<FlexRow style={{ justifyContent: 'center', textAlign: 'center', paddingTop: '0.5rem' }}>
						<Bold>Rules:</Bold>
					</FlexRow>

					<FlexRow style={{ justifyContent: 'left', textAlign: 'left', paddingBottom: '0.5rem' }}>
						<ul style={{ listStyle: 'circle' }}>
							<li>
								<Bold>Do not alter</Bold> the file headers.	
							</li>

							<li>
								<Bold>Item ID</Bold> is a mandatory field.
							</li>

							{selectedDeleteOption === SPJ_ACTIONS.INVENTORY_DELETE_INDEX
							?	<li>
									<Bold>Un Map From Particular DSOs</Bold> can be selected and copied from the dropdown given below. Multiple DSOs have to be separated using a <Bold>||</Bold> symbol.
								</li>
							:	null
							}	
						</ul>
					</FlexRow>

					<SectionRow>
						<InputGroup
							label='Select the type of delete action you want to perform'
							markRequired={true}
						>
							<Select
								name={'delete_type'}
								placeholder='Select delete type'
								value={selectedDeleteOption}
								disabled={false}
								onChange={(e) => {
									this.handleInput('selectedDeleteOption', e.target.value);
								}}
							>
								{deleteOptions.map((item) => (
									<MenuItem
										value={item.value}
										disabled={item.disabled}
									>
										{item.name}
									</MenuItem>
								))}
							</Select>
						</InputGroup>
					</SectionRow>

					{selectedDeleteOption === SPJ_ACTIONS.INVENTORY_DELETE_INDEX
					?	<SectionRow>
							{!hideDSOInfo(groupId) ? (
								<InputGroup label='Find DSO Alias'>
									<Select
										multiple
										name={'mapped_dso_ids'}
										placeholder='Select value'
										value={mappedDSOIds.length ? mappedDSOIds : []}
										disabled={false}
										onChange={(e) => {
											this.handleInput('mappedDSOIds', e.target.value);
										}}
										endAdornment={
											<InputAdornment>
												<CopyIcon
													onClick={(e) => {
														this.handleCopyInput(mappedDSOIds);
													}}
												/>
											</InputAdornment>
										}
									>
										{!mappedDSOOptions.length ? (
											<MenuItem
												key={'NO DSO OPTIONS AVAILABLE'}
												value={''}
												disabled={true}
											>
												NO DSO OPTIONS AVAILABLE
											</MenuItem>
										) : null}

										{mappedDSOOptions.map((item) => (
											<MenuItem
												key={item.name}
												value={item.name}
												disabled={item.disabled}
											>
												{item.name}
											</MenuItem>
										))}
									</Select>

									{mappedDSOIds && mappedDSOIds.length ? (
										<span>
											Use <Bold>{mappedDSOIds.join(' || ')}</Bold> in XLSX
										</span>
									) : null}
								</InputGroup>
							) : null}
						</SectionRow>
					:	null
					}
					
				</BulkUpload>
			</>
		) : null;
	}
}

const mapStateToProps = (state) => {
	let supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	let userSellerPortalConfig = state.session.sellerPortalConfig || {};

	let disableBulkUploadInventoryDelete = supplierSellerPortalConfig.disable_bulk_upload_inventory_delete || userSellerPortalConfig.disable_bulk_upload_inventory_delete || false;
	let disableBulkUploadIndexDelete = supplierSellerPortalConfig.disable_bulk_upload_index_delete || userSellerPortalConfig.disable_bulk_upload_index_delete || false;

	const deleteOptions = [];
	// if (!disableBulkUploadInventoryDelete) {
	// 	deleteOptions.push({ name: 'Delete from everywhere', value: SPJ_ACTIONS.INVENTORY_DELETE, disabled: false });
	// }
	if (!disableBulkUploadIndexDelete) {
		deleteOptions.push({ name: 'Delete from particular index', value: SPJ_ACTIONS.INVENTORY_DELETE_INDEX, disabled: false });
	}

	return {
		groupId: state.session.groupId,
		uploadInventoryFileAction: state.inventory.uploadInventoryFileAction || '',
		uploadInventoryFileBatch: state.inventory.uploadInventoryFileBatch || '',
		uploadInventoryFileType: state.inventory.uploadInventoryFileType || '',
		mappedDSOOptions: state.inventory.mappedDSOOptions || [],
		deleteOptions
	};
};

const mapDispatch = {
	setUploadInventoryFileAction,
	downloadTemplateFile,
	uploadFilledTemplateFile,
	setUploadInventoryFileBatch,
	fetchSPJBatchJobs,
	fetchSPJBatchMetric,
	clearSPJFailed,
	downloadSPJErrors,
	updateError,
	updateErrorMessage,
	updateMessage,
	updateSuccessMessage,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(DeleteBulkItems));
